import { hasPermission } from "../utils/hasPermission";

export const permission = localStorage.getItem("permissions");
// console.log(permission);

export const permissions = permission ? hasPermission(permission) || [] : [];
